const department = [
  {
    name: 'A & E',
    Percent: 8.1,
  },
  {
    name: 'Blog',
    Percent: 5.9,
  },
  {
    name: 'Design',
    Percent: 13.5,
  },
  {
    name: 'Multimedia',
    Percent: 7.7,
  },
  {
    name: 'News',
    Percent: 20.3,
  },
  {
    name: 'Night',
    Percent: 7.2,
  },
  {
    name: 'Opinion',
    Percent: 3.6,
  },
  {
    name: 'Sports',
    Percent: 8.1,
  },
  {
    name: 'Photo',
    Percent: 8.6,
  },
  {
    name: 'Projects',
    Percent: 5,
  },
  {
    name: 'Social Media',
    Percent: 7.2,
  },
  {
    name: 'The Weekender',
    Percent: 6.8,
  },
  {
    name: 'Business Operations',
    Percent: 0.9,
  },
  {
    name: 'Marketing',
    Percent: 1.8,
  },
  {
    name: 'Development',
    Percent: 1.4,
  },
  {
    name: 'Online / tech',
    Percent: 0.5,
  },
  {
    name: 'Upper Management',
    Percent: 0.5,
  },
  {
    name: 'Special Issues',
    Percent: 0.5,
  },
];

export default department;
